<template>
  <b-form-group
    :label="label"
    :label-for="name"
    :description="helptext"
  >
    <b-form-textarea 
      :id="name"
      :value="model"
      @input="input()"
      v-model.trim="state"
      :rows="rows?rows:3"
      :max-rows="0"
      :disabled="disabled"
      v-if="type==='textarea'"
    />
    <vue-editor
      class="pinput-vue-editor"
      :id="name"
      :value="model"
      @input="input()"
      v-model.trim="state"
      :rows="rows?rows:3"
      :max-rows="0"
      v-else-if="type==='editor'"
    />
    <b-form-input 
      :id="name"
      :value="model" 
      @input="input()"
      v-model.trim="state"
      :placeholder="label" 
      :type="type"
      v-else
      :disabled="disabled"
    />
    <slot></slot>
    <div v-if="formHandle.$error">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  data: () => {
    return {
      state: ''
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number | String
    },
    helptext: {
      type: String
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  methods: {
    input () {
      this.$emit('updateModel', this.state)
    }
  },
  watch: {
    'model': function () {
      this.state = this.model
    }
  },
  components: {
    VueEditor
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>

<style>
.pinput-vue-editor .ql-container {
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/custom/PInput.vue